import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '@/layout'

/* Router Modules */
import InformationRouter from './modules/cargo/v0/Information'
import SystemMaintenanceRouter from './modules/cargo/v0/SystemMaintenance'
import SystemMonitorRouter from './modules/cargo/v0/SystemMonitor'
import SystemClearingRouter from './modules/cargo/v0/Clearing'
import SeaExportRouter from './modules/cargo/v0/SeaExport'
import ProjectManageRouter from './modules/cargo/v0/ProjectManage'
import OMSRouter from './modules/cargo/v0/OMS'
import SeaImportRouter from './modules/cargo/v0/SeaImport'
import AirExportRouter from './modules/cargo/v0/AirExport'
import AirImportRouter from './modules/cargo/v0/AirImport'
import RailwayExportRouter from './modules/cargo/v0/RailwayExport'
import SalesRouter from './modules/cargo/v0/Sales'
import DestinationBusinessRouter from './modules/cargo/v0/DestinationBusiness'
import RobotRouter from './modules/cargo/v0/Robot'
import FinanceManageRouter from '@/router/modules/cargo/v0/FinanceManage'
import PriceRouter from './modules/cargo/v0/Price'
import TenantMaintain from './modules/cargo/v0/TenantMaintain'
import BiAnalysis from './modules/cargo/v0/BiAnalysis'
import FBARouter from './modules/cargo/v0/FBA'
import Integrated from './modules/cargo/v0/Integrated'
import ApprovalMattersRouter from './modules/cargo/v0/ApprovalMatters'
import PillReportRouter from './modules/cargo/v0/PillReport'
import OpenPriceRouter from './modules/cargo/v0/OpenPrice'
import PerformanceRouter from './modules/cargo/v0/Performance'

/** note: sub-menu only appear when children.length>=1
 *  detail see  https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 **/

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    will control the page roles (you can set multiple roles)
    title: 'title'               the name show in sub-menu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar
    noCache: true                if true, the page will no be cached(default is false)
    breadcrumb: false            if false, the item will hidden in breadcrumb(default is true)
    affix: true                  if true, the tag will affix in the tags-view
  }
 **/

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 * */
export const constantRoutes = [
  {
    name: 'Redirect',
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/redirect/:path*',
        component: () => import('@/views/redirect/index')
      }
    ]
  },
  {
    name: 'Login',
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true
  },
  {
    name: 'AuthRedirect',
    path: '/auth-redirect',
    component: () => import('@/views/login/authredirect'),
    hidden: true
  },
  {
    name: '401',
    path: '/401',
    component: () => import('@/views/errorPage/401'),
    hidden: true
  }, {
    name: '404',
    path: '/404',
    component: () => import('@/views/errorPage/404'),
    hidden: true
  }, {
    name: 'analysis',
    path: '/analysis',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '',
        name: 'AnalysisDetails',
        component: () => import('@/views/cargo/v0/Analysis'),
        meta: { title: '统计分析', enTitle: 'Statistics Analysis', jaTitle: '集計一覧表', ruTitle: 'Статистический анализ', thTitle: 'การวิเคราะห์ทางสถิติ', viTitle: 'Phân tích thống kê' }
      }
    ]
  },
  // {
  //   name: 'Index',
  //   path: '',
  //   component: Layout,
  //   redirect: '/Information/Seaport'
  // },
  {
    name: 'UiDocument',
    path: '/ui-document',
    redirect: 'noredirect',
    hidden: true,
    component: Layout,
    children: [
      {
        name: 'UiDocumentIndex',
        path: 'index',
        component: () => import('@/views/ui-document/index'),
        meta: { title: '前端开发规范' }
      }
    ]
  },
  {
    name: 'Index',
    path: '',
    component: Layout,
    redirect: 'dashboard',
    hidden: true,
    children: [
      {
        path: 'dashboard',
        component: () => import('@/views/dashboard/index'),
        name: 'Dashboard',
        meta: { title: '首页', enTitle: 'Dashboard', jaTitle: '看板', ruTitle: 'Главная страница', thTitle: 'หน้าหลัก', viTitle: 'Trang chủ', icon: 'dashboard', noCache: true, affix: true }
      },
      {
        path: 'DataTracking',
        component: () => import('@/views/cargo/v0/SeaExport/components/booking/tabs/TabDataTracking/index'),
        name: 'TabDataTracking',
        meta: { title: '数据追踪' },
        roles: []
      },
      { // 东京海上保单详情
        path: 'PolicyDetail',
        component: () => import('@/views/cargo/v0/Insurance/dongJingHaiShang/policyDetail'),
        name: 'PolicyDetail',
        meta: { title: '投保', enTitle: 'Insurance' },
        roles: []
      },
      { // 投保
        path: 'ToInsurePage',
        component: () => import('@/views/cargo/v0/Insurance/components/toInsurePage'),
        name: 'ToInsurePage',
        meta: { title: '投保', enTitle: 'ToInsurePage' },
        roles: []
      },
      { // 计提查询详情（从列表页按钮跳转）
        path: 'JobDetail',
        component: () => import('@/views/cargo/v0/ProvisionData/JobDetail'),
        name: 'JobDetail',
        meta: { title: '计提查询详情', enTitle: 'Provision Query Detail' },
        roles: [] // 隐藏路由，不需要权限验证，由按钮级别控制
      },
      { // 自定义页面
        path: 'CustomPage',
        component: () => import('@/views/cargo/v0/SystemMaintenance/pageUserUICustom'),
        name: 'CustomPage',
        meta: { title: '自定义页面', enTitle: 'Custom Page' },
        roles: []
      },
      { // 官网订单接单列表（开发期 URL /SalesWebOrder 直达；生产由后端 sys-service 菜单 Sales/SalesWebOrder + module_WebOrder 驱动）
        path: 'SalesWebOrder',
        component: () => import('@/views/cargo/v0/Sales/webOrder'),
        name: 'SalesWebOrder',
        meta: { title: '接单列表' },
        roles: []
      },
      { // 费用解锁台账（开发期 URL /UnlockLedger 直达；生产由后端菜单配置 h5Component=Clearing/UnlockLedger/index 驱动，页面/按钮权限点 button_unlock_ledger:view、button_unlock_admin）
        path: 'UnlockLedger',
        component: () => import('@/views/cargo/v0/Clearing/UnlockLedger/index'),
        name: 'UnlockLedger',
        meta: { title: '解锁台账', enTitle: 'Unlock Ledger', jaTitle: 'ロック解除台帳', ruTitle: 'Журнал разблокировки', thTitle: 'บันทึกปลดล็อก', viTitle: 'Sổ mở khóa' },
        roles: []
      }
    ]
  },
  { // 尾程商务/海外跟单 - 各业务类型独立详情页（精简版，仅返回/编辑/保存）
    name: 'DestinationBusinessDetail',
    path: '/DestinationBusiness',
    component: Layout,
    hidden: true,
    redirect: 'noredirect',
    children: [
      {
        path: 'SeDetail',
        component: () => import('@/views/cargo/v0/DestinationBusiness/detail/seDetail'),
        name: 'DestinationBusinessSeDetail',
        meta: { title: '尾程商务-海运出口详情', hidden: true, activeMenu: '/DestinationBusiness/EndCommerce' },
        props: true
      },
      {
        path: 'SiDetail',
        component: () => import('@/views/cargo/v0/DestinationBusiness/detail/siDetail'),
        name: 'DestinationBusinessSiDetail',
        meta: { title: '尾程商务-海运进口详情', hidden: true, activeMenu: '/DestinationBusiness/EndCommerce' },
        props: true
      },
      {
        path: 'AeDetail',
        component: () => import('@/views/cargo/v0/DestinationBusiness/detail/aeDetail'),
        name: 'DestinationBusinessAeDetail',
        meta: { title: '尾程商务-空运出口详情', hidden: true, activeMenu: '/DestinationBusiness/EndCommerce' },
        props: true
      },
      {
        path: 'AiDetail',
        component: () => import('@/views/cargo/v0/DestinationBusiness/detail/aiDetail'),
        name: 'DestinationBusinessAiDetail',
        meta: { title: '尾程商务-空运进口详情', hidden: true, activeMenu: '/DestinationBusiness/EndCommerce' },
        props: true
      },
      {
        path: 'ReDetail',
        component: () => import('@/views/cargo/v0/DestinationBusiness/detail/reDetail'),
        name: 'DestinationBusinessReDetail',
        meta: { title: '尾程商务-铁路出口详情', hidden: true, activeMenu: '/DestinationBusiness/EndCommerce' },
        props: true
      },
      {
        path: 'IeDetail',
        component: () => import('@/views/cargo/v0/DestinationBusiness/detail/ieDetail'),
        name: 'DestinationBusinessIeDetail',
        meta: { title: '尾程商务-综合物流详情', hidden: true, activeMenu: '/DestinationBusiness/EndCommerce' },
        props: true
      }
    ]
  }
]

/**
 * asyncRoutes
 * the routes that need to be dynamically loaded based on user roles
 * 路由动态获取了，待废弃
 */
export const asyncRoutes = [
  InformationRouter,
  SystemMaintenanceRouter,
  SystemMonitorRouter,
  SeaExportRouter,
  SystemClearingRouter,
  ProjectManageRouter,
  OMSRouter,
  SeaImportRouter,
  AirExportRouter,
  AirImportRouter,
  RailwayExportRouter,
  SalesRouter,
  DestinationBusinessRouter,
  RobotRouter,
  FinanceManageRouter,
  PriceRouter,
  TenantMaintain,
  BiAnalysis,
  FBARouter,
  Integrated,
  ApprovalMattersRouter,
  PillReportRouter,
  OpenPriceRouter,
  PerformanceRouter,
  { path: '*', name: '404', redirect: '/404', hidden: true }
]

const createRouter = () => new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
